// @flow

import type { ComponentType } from 'react';
import { connect } from 'react-redux';
import SearchResults from './searchResults';
import { getFAQResultsItems } from '../../../store/routes/selectors';
import type { FAQItemInCategory } from '../../../types/faq';

type OwnProps = {|
  noResultsHeader: string,
  resultsHeader: string,
|};

type StateProps = {|
  results: ?Array<FAQItemInCategory>,
|};

const mapStateToProps = (state): StateProps => ({
  results: getFAQResultsItems(state) || [],
});

const SearchResultsContainer: ComponentType<OwnProps> = connect(mapStateToProps)(SearchResults);

export default SearchResultsContainer;
